import { Button, Text, Tooltip, Transition } from "@mantine/core";
import { useEffect, useRef, useState } from "react";

interface ProactiveSuggestionButtonProps {
    onClick: (button: string) => void;
    shouldShow: boolean;
    suggestion: string;
}

export function ProactiveSuggestionButton({ onClick, shouldShow, suggestion }: ProactiveSuggestionButtonProps) {
    const textRef = useRef<HTMLDivElement>(null);
    const [isTextTruncated, setIsTextTruncated] = useState(false);

    useEffect(() => {
        const element = textRef.current;
        if (!element) return;

        const checkTruncation = () => {
            setIsTextTruncated(element.scrollWidth > element.clientWidth);
        };

        checkTruncation();
        const resizeObserver = new ResizeObserver(checkTruncation);
        resizeObserver.observe(element);

        return () => {
            resizeObserver.disconnect();
        };
    }, []);

    return (
        <Transition duration={400} mounted={shouldShow} transition="slide-left" timingFunction="ease">
            {(transitionStyles) => (
                <Tooltip label={suggestion} zIndex="var(--mantine-priority-higher)" disabled={!isTextTruncated}>
                    <Button
                        size="xs"
                        flex="1"
                        miw="2rem"
                        maw="fit-content"
                        key={suggestion}
                        onClick={() => onClick(suggestion)}
                        style={{ ...transitionStyles }}
                    >
                        <Text size="xs" truncate ref={textRef}>
                            {suggestion}
                        </Text>
                    </Button>
                </Tooltip>
            )}
        </Transition>
    );
}
